import React from 'react';
import { FaCheck } from 'react-icons/fa';
import './ProjectWizard.css';

const ProjectWizard = ({ currentStep, steps = [], onStepClick }) => {
    const totalSteps = steps && steps.length > 0 ? steps.length : 1;
    
    const progressPercent = totalSteps > 1 ? (currentStep / (totalSteps - 1)) * 100 : 0;

    return (
        <div 
            className="wizard-stepper-container project-wizard-container"
            style={{ '--total-steps': totalSteps }}
        >
            <div className="step-indicator-wrapper">
                <div className="step-progress-track">
                    <div 
                        className="step-progress-fill" 
                        style={{ width: `${progressPercent}%` }}
                    ></div>
                </div>
                {steps.map((step, index) => (
                    <div
                        key={step.id || index}
                        className={`step-item ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'completed' : ''}`}
                        onClick={() => onStepClick && onStepClick(index)}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="step-circle">{index < currentStep ? <FaCheck /> : index + 1}</div>
                        <div className="step-label">{step.title}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProjectWizard;